import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { Popover } from "antd";

import StepPopupUnassign from "./StepPopupUnassign";

const UnScheduledSteps = ({
  steps,
  stepsHovered,
  setStepsHovered,
  onClickStep,
  onHoverStep,
  handleCloseStepPopup,
  setting,
  selectedMultipleSteps,
  setAllInclusiveMultipleSteps,
  multipleStepState,
}) => {
  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, "unscheduled");
    } else if (e.shiftKey) {
      setAllInclusiveMultipleSteps && setAllInclusiveMultipleSteps(step, "unscheduled");
    } else {
      onClickStep(step.orderId, step.type);
    }
  };

  return (
    <>
      {steps.map((step, indexStep) => {
        const keyDraggable = `draggable${step.id}${indexStep}`;
        const stepPopover = `StepPopover-${step.orderId}-${step.type.toLowerCase()}`;
        const isMultipleSelected = multipleStepState?.steps?.find(
          item => item.orderId === step.orderId && item.type === step.type && item.driverId === "unscheduled",
        );
        return (
          <Draggable key={keyDraggable} draggableId={keyDraggable} index={indexStep}>
            {provided => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                  zIndex: 99,
                  width: 24,
                  marginLeft: "8px",
                  ...provided.draggableProps.style,
                }}>
                <Popover
                  key={indexStep}
                  trigger="hover"
                  open={stepsHovered[stepPopover] || false}
                  content={
                    <StepPopupUnassign
                      step={step}
                      stepPopover={stepPopover}
                      setStepsHovered={setStepsHovered}
                      onClickStep={onClickStep}
                      setting={setting}
                    />
                  }>
                  <div
                    className={`${step.type.toLowerCase() === "pickup" ? "unit" : "unit unit2"} ${stepPopover}`}
                    style={{
                      borderColor: step.color,
                      color: step.color,
                      borderWidth: isMultipleSelected ? "3px" : "1px",
                    }}
                    onClick={e => newClickStep(e, step)}
                    onMouseOver={() => onHoverStep(step.orderId, step.type)}
                    onMouseOut={() => handleCloseStepPopup()}>
                    {step.index + 1}
                  </div>
                </Popover>
              </div>
            )}
          </Draggable>
        );
      })}
    </>
  );
};

export default UnScheduledSteps;
